import styled, { createGlobalStyle } from 'styled-components';
import { breakpoints } from '../../../constants/Constants';

interface AccordionProps {
  isExpanded?: boolean;
}

// Global style to ensure filter dropdown menus appear above accordion content
export const FilterDropdownStyles = createGlobalStyle`
  .menu-list {
    z-index: 9999 !important;
  }
`;

export const FilterBarContainer = styled.div`
  height: 64px;
  flex-shrink: 0;
  background-color: ${(props) => props.theme?.colors?.backgroundLayer1};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 999;
  // gap: 16px;

  @media (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    height: auto;
    padding: 16px 24px;
  }
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-flow: row wrap;

  @media (max-width: ${breakpoints.desktop}) {
    flex-flow: column nowrap;
    width: 100%;
    align-items: flex-end;
  }
`;

export const FrequencyFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: ${breakpoints.desktop}) {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
  }
`;

export const AccordionHeader = styled.div`
  display: none;

  @media (max-width: ${breakpoints.desktop}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 4px 0;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    user-select: none;
    color: ${(props) => props.theme?.colors?.textPrimary};

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AccordionToggle = styled.span<AccordionProps>`
  display: none;

  @media (max-width: ${breakpoints.desktop}) {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;

    svg {
      font-size: 24px;
      color: ${(props) => props.theme?.colors?.icon};
    }
  }
`;

export const AccordionContent = styled.div<AccordionProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    display: ${({ isExpanded }) => (isExpanded ? 'flex' : 'none')};
    gap: 12px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;
